<template>
  <div style="margin: 10px;">
    <v-btn-toggle mandatory class="people-list-toggle" v-model="list">
      <v-btn value="organizers">Organizers</v-btn>
      <v-btn value="contributors">Contributors</v-btn>
      <v-btn value="registered">Registered</v-btn>
      <v-btn value="prospects">Prospects</v-btn>
    </v-btn-toggle>

    <v-select
      class="people-list-select"
      autocomplete
      solo dense
      placeholder="Select a list to see people"
      :items="['organizers', 'contributors', 'registered', 'prospects']"
      v-model="list"
      >
    </v-select>

    <h3 v-if="!loading && noData" style="text-align: center">No people available.</h3>

    <div v-if="loading" class="loader">
      <loader/>
    </div>
    <div v-else class="person-row" v-for="people in peoples" :key="people.user_id">
      <v-list-tile-avatar>
        <img v-if="people.avatar" :src="people.avatar" :alt="people.username.charAt(0)">
        <v-avatar size="40px" v-else class="red">
          <span class="headline white--text">{{ people.username.charAt(0).toUpperCase() }}</span>
        </v-avatar>
      </v-list-tile-avatar>
      <div class="person-details">
        <router-link class="person-name" :to="{name: 'UserProfile', params: {id: people.user_id}, query: { ref_task_id: taskId}}">
          {{ people.username }}
        </router-link>

        <div class="person-date">
          <span v-if="people.task_contributor_date">Completed on {{ people.task_contributor_date | formatDate }}</span>
          <span v-else-if="people.user_registered">Registered on {{ people.task_contributor_date | formatDate }}</span>
        </div>
      </div>
    </div>
  </div>


  <!-- <div class="task-people">

  </div> -->
</template>

<script>
import moment from 'moment';
import get from 'lodash/get';
import { taskGetPeople } from '@/api';

import Loader from '@/components/Loader';

export default {
  components: {
    Loader,
  },
  data() {
    return {
      list: 'organizers',
      loading: false,
      peoples: [],
    };
  },
  computed: {
    taskId() {
      return this.$route.params.id;
    },
    noData() {
      return this.peoples.length === 0;
    },
  },
  filters: {
    formatDate(date) {
      return moment(date).format('MMM D, hh:mm a');
    },
  },
  methods: {
    fetchTaskPeople: async function fetchTaskPeople() {
      this.loading = true;
      this.peoples = [];
      const userToken = this.$store.getters['auth/userToken'];
      const taskId = this.$route.params.id;
      const { data } = await taskGetPeople(userToken, taskId, this.list);
      const status = get(data, '[1].status');
      const errorType = get(data, '[1].error.error_type');

      this.loading = false;
      if (status === 'SUCCESS') {
        this.peoples = Object.values(get(data, '[1].data.details', {}));
      } else if (errorType === 'NO_DATA') {
        // do nothing at the moment
      } else {
        const message = get(data, '[1].error.error_usr_msg', 'Failed to fetch list of people');
        this.$store.dispatch('auth/setFlashMessage', {
          message,
          type: 'danger',
        });
      }
    },
  },
  watch: {
    list() {
      this.fetchTaskPeople();
    },
  },
  mounted() {
    this.fetchTaskPeople();
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

.people-list-toggle {
  height: 35px !important;
}

.people-list-select {
  margin-bottom: 15px;
  display: none;
}

@media screen and (max-width: 600px) {
  .people-list-select {
    display: block;
  }

  .people-list-toggle {
    display: none;
  }
}

.person-row {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid $lighter;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

.person-row:last-child {
  border-bottom: none;
}

.person-details {
  display: flex;
  flex-direction: column;
}

.person-name {
  font-size: 16px;
  font-weight: bold;
  text-decoration: none;
  color: $blue;
}

.person-date {
  font-size: 12px;
  font-weight: lighter;
  color: $light;
}

.loader {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>





// WEBPACK FOOTER //
// src/components/TaskDetailsPeople.vue